import { render } from "./dietRecommend.vue?vue&type=template&id=13be394e&scoped=true"
import script from "./dietRecommend.vue?vue&type=script&lang=js"
export * from "./dietRecommend.vue?vue&type=script&lang=js"

import "./dietRecommend.vue?vue&type=style&index=0&id=13be394e&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be394e"]])

export default __exports__